<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <form [formGroup]="resetPasswordForm" class="reset-password-form" (ngSubmit)="onSubmit()">
        <div class="reset-password-content" *ngIf="state === 1">
          <div class="header-message">Please enter your registered email address below and click Reset password</div>
          <div class="form-wrapper">
            <div *ngIf="showError">
              <p class="error-message text-center">Email not recognised, please try again</p>
            </div>
            <div class="form-group">
              <input type="email" class="form-control content-input" formControlName="email" required placeholder="Your email" [ngClass]="{
                  'is-valid': emailCtrl.valid && emailCtrl.touched,
                  'is-invalid': !emailCtrl.valid && (emailCtrl.touched || submitted)
                }" />
            </div>
            <div class="form-group">
              <button class="btn btn-block btn-greengo" type="submit" npFocusOutClicked>Reset password</button>
            </div>
            <div class="return-login">
              <a routerLink="/auth/login" class="link return-login-link">Return to log in screen</a>
            </div>
          </div>
        </div>
        <div class="send-email-sucess" *ngIf="state === 2">
          <div class="header-message">
            If the username entered is correct, you will receive further instructions via email.
          </div>
          <div class="form-group return-login-btn">
            <button class="btn btn-block btn-greengo" (click)="returnLogin()">Return to log in screen</button>
          </div>
        </div>
      </form>
      <div class="footer">
        <p class="p-footer">Don’t have an account?
          <a routerLink="/auth/register" class="link">Sign up</a>
        </p>
      </div>
    </div>
  </div>
</div>
